var _defs, _polygon, _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCaixaDeFibra = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #171954;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 2.71px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.36 16.09 57.45 22.09 57.45 54.65 40.36 61.81 40.36 16.09"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29.97,17.44c2.96-.63,5.93-1.25,8.89-1.88.5.17,1,.35,1.5.52v45.72c-.44.23-.89.46-1.33.69-3.02-.85-6.04-1.69-9.06-2.54V17.44Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.83,
    y1: 28,
    x2: 29.97,
    y2: 28
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.83,
    y1: 37.5,
    x2: 29.97,
    y2: 37.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.83,
    y1: 47,
    x2: 29.97,
    y2: 47
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCaixaDeFibra);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CAIXA_DE_FIBRA.4f3b2ff39a97568825f582eb905eb844.svg";